@if (!isHoverPreview()) {
  <div class="dialog-backdrop" [attr.data-testid]="testIds.profileBackdrop"></div>
}
<div
  class="profile-card"
  [class.hover-preview]="isHoverPreview()"
  (click)="$event.stopPropagation()"
  [attr.data-testid]="testIds.profileCard"
  (keydown)="$event.stopPropagation()">
  @if (!isHoverPreview()) {
    <div class="profile-header" [attr.data-testid]="testIds.profileHeader">
      <button class="back-button" (click)="closeDialog()" [attr.data-testid]="testIds.buttonBack">
        <mat-icon svgIcon="arrow-left"></mat-icon>
        Zurück
      </button>
    </div>
    <h1 class="profile-title" [attr.data-testid]="testIds.profileTitle">Kontakt</h1>
    <hr class="title-separator" />
  }
  <div class="user-info-row" [attr.data-testid]="testIds.userInfoRow">
    <div class="avatar-container" [attr.data-testid]="testIds.avatarContainer">
      <app-user-icon [userId]="effectiveMember?.mxid || ''" [showStatus]="false" class="user-avatar"> </app-user-icon>
    </div>
    <div class="user-name" [attr.data-testid]="testIds.userName" [class.no-kvnr]="!isInsuredPerson()">
      {{ effectiveMember?.rawDisplayName || effectiveMember?.name || 'Unknown User' }}
      @if (isInsuredPerson()) {
        <div class="kvnr-text" [attr.data-testid]="testIds.kvnrText">
          KV-Nr.: {{ getKVNR() }}
          <button
            mat-icon-button
            (click)="copyKVNR(); $event.stopPropagation()"
            matTooltip="KVNR kopieren"
            [attr.data-testid]="testIds.buttonCopyKvnr">
            <mat-icon svgIcon="copy" class="copy-icon"></mat-icon>
          </button>
        </div>
      }
    </div>

    <div class="user-status" [attr.data-testid]="testIds.userStatus">
      <span class="status-text" [attr.data-testid]="testIds.statusText">
        {{ presenceStatus === 'online' ? 'Online' : 'Offline' }}
      </span>
      <mat-icon
        class="status-icon"
        [svgIcon]="presenceStatus === 'online' ? 'online' : 'offline'"
        [style.color]="presenceStatus === 'online' ? 'green' : 'grey'"
        [attr.data-testid]="testIds.statusIcon">
      </mat-icon>
    </div>
  </div>
  <div class="contact-info" [attr.data-testid]="testIds.contactInfo">
    <div class="tim-address">
      <span class="tim-label">TIM-Adresse:.</span>
      <span class="tim-value">{{ getTimAddress() }}</span>
    </div>
  </div>
  @if (commonRooms.length > 0) {
    <div class="common-rooms-section" [attr.data-testid]="testIds.commonRoomsSection">
      <h2>Gemeinsame Chats</h2>
      @for (room of isHoverPreview() ? hoverDisplayedCommonRooms : displayedCommonRooms; track room.roomId) {
        <mat-card
          class="common-room-card"
          (click)="navigateToRoom($event, room.roomId)"
          [attr.data-testid]="testIds.cardCommonroom"
          (keydown)="$event.stopPropagation()">
          <mat-card-header>
            <app-user-icon
              [userId]="(getLastMessageSender$(room.roomId) | async)!"
              [showStatus]="false"
              class="left-icon">
            </app-user-icon>
          </mat-card-header>
          <mat-card-content>
            <div class="card-content-wrapper">
              <div class="card-title-wrapper">
                <mat-card-title>{{ getRoomTitle$(room) | async }}</mat-card-title>
                @let lastMessageData = (lastMessageService.lastMessageDict$ | async)!;
                @if (lastMessageData.get(room.roomId)?.timestamp) {
                  <span class="timestamp" [attr.data-testid]="testIds.commonroomTimestamp">
                    {{
                      DateUtils.isToday(lastMessageData.get(room.roomId)?.timestamp)
                        ? (lastMessageData.get(room.roomId)?.timestamp | date: 'HH:mm')
                        : (lastMessageData.get(room.roomId)?.timestamp | date: 'dd.MM.yyyy')
                    }}
                  </span>
                }
              </div>
              <div
                class="card-message"
                [attr.data-testid]="testIds.commonroomMessage"
                [innerHTML]="getLastMessagePreview$(room.roomId) | async"></div>
            </div>
          </mat-card-content>
        </mat-card>
      }
      <div
        class="paginator-container"
        (click)="$event.stopPropagation()"
        [attr.data-testid]="testIds.paginatorCommonrooms"
        (keydown)="$event.stopPropagation()">
        <mat-paginator
          [length]="commonRooms.length"
          [pageSize]="isHoverPreview() ? hoverPageSize : pageSize"
          [pageSizeOptions]="[]"
          [hidePageSize]="true"
          (page)="isHoverPreview() ? handleHoverPageEvent($event) : handlePageEvent($event)"
          aria-label="Select page">
        </mat-paginator>
      </div>
    </div>
  }
  @if (!isCurrentUser()) {
    <div
      class="privacy-container"
      (click)="$event.stopPropagation()"
      [attr.data-testid]="testIds.messageSection"
      (keydown)="$event.stopPropagation()">
      <div class="button-container">
        <app-button
          [isPrimary]="true"
          class="submit-btn"
          text="Nachricht schreiben"
          (click)="toggleMessageInput(); $event.stopPropagation()"
          type="button"
          [dataTestId]="'button_write_message'"
          (keydown)="$event.stopPropagation()">
        </app-button>
      </div>
      @if (showMessageInput) {
        <div
          class="message-input-container"
          (click)="$event.stopPropagation()"
          [attr.data-testid]="testIds.messageInputContainer"
          (keydown)="$event.stopPropagation()">
          <textarea
            [(ngModel)]="messageText"
            (keydown)="$event.stopPropagation()"
            placeholder="Nachricht schreiben..."
            class="message-input"
            (keydown.enter)="sendMessage()"
            [attr.data-testid]="testIds.messageTextarea">
          </textarea>
          <button
            class="send-button"
            mat-icon-button
            type="button"
            (click)="sendMessage()"
            [attr.data-testid]="testIds.buttonSendMessage">
            <mat-icon svgIcon="send-message"></mat-icon>
          </button>
        </div>
      }
    </div>
  }
</div>
